import { Component } from '@angular/core';
import { EdsSpinnerComponent } from '@eventim/eds2/spinner';

@Component({
  selector: 'tlm-full-screen-spinner',
  imports: [EdsSpinnerComponent],
  template: `<div class="flex h-screen w-screen items-center justify-center">
    <eds-spinner diameter="40" />
  </div>`,
})
export class FullScreenSpinner {}
